export default __webpack_public_path__ + "static/squid-game-921eab59458d383fb2ff26262f8c1f0d.png";